import React from 'react';
import logo from '../../logo_ ADT.svg';
import '../expirePage/_expired.scss';

function NoPage() {
    return (
        <>
            <div className="expire-block text-center">
                <div className="custom-width">
                    <img className="site-logo mb-4" src={logo} alt="ADT Logo" />
                    <p className="expire-content">
                        Something went wrong and we're looking into it.
                    </p>
                </div>
            </div>
        </>
    );
}

export default NoPage;
